import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackTrafficSource } from '../utils/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();
  const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
  
  console.log('GA4 Debug:', {
    GA_MEASUREMENT_ID,
    NODE_ENV: process.env.NODE_ENV,
    shouldLoad: GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX' && GA_MEASUREMENT_ID.startsWith('G-')
  });

  useEffect(() => {
    // Skip GA4 loading for development/localhost traffic
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' || 
                       window.location.hostname.includes('localhost');
    
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    // Only load GA4 if measurement ID is provided and valid, and not in development
    if (GA_MEASUREMENT_ID && 
        GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX' && 
        GA_MEASUREMENT_ID.startsWith('G-') &&
        !isLocalhost && 
        !isDevelopment) {
      
      // Load Google Analytics script
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      script.async = true;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        page_title: document.title,
        page_location: window.location.href,
        // Enhanced e-commerce settings
        send_page_view: true,
        // Traffic source attribution settings
        campaign_source_detection: true,
        enhanced_link_attribution: true,
        // Privacy settings
        anonymize_ip: true,
        allow_google_signals: false,
        allow_ad_personalization_signals: false,
        // Custom parameters for better attribution
        custom_map: {
          'custom_parameter_1': 'traffic_source'
        }
      });

      return () => {
        // Cleanup script if component unmounts
        const scripts = document.querySelectorAll(`script[src*="googletagmanager"]`);
        scripts.forEach(script => script.remove());
      };
    }
  }, [GA_MEASUREMENT_ID]);

  // Track page views on route changes
  useEffect(() => {
    // Skip tracking for development/localhost traffic
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1' || 
                       window.location.hostname.includes('localhost');
    
    const isDevelopment = process.env.NODE_ENV === 'development';
    
    if (GA_MEASUREMENT_ID && 
        GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX' && 
        GA_MEASUREMENT_ID.startsWith('G-') &&
        !isLocalhost && 
        !isDevelopment) {
      
      const pageTitle = document.title || 'Lumi Bears';
      trackPageView(location.pathname, pageTitle);
      
      // Track detailed traffic source information to help debug "Unassigned" traffic
      trackTrafficSource();
    }
  }, [location, GA_MEASUREMENT_ID]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;